module.exports = __webpack_public_path__ + "static/media/panel-image-tarjeta.9d5685ac.jpg";